<template>
  <div v-if="!isLoading" class="series-list-box">
    <ul class="series-list">
      <li
        v-for="(thumb, index) in seriesCellList"
        :key="`series_thumb_${index}`"
        class="item"
      >
        <SeriesCell :thumb="thumb" />
      </li>
      <li v-if="isOdd" class="item" aria-hidden="true">&nbsp;</li>
    </ul>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { getMovieSeriesContents } from '@/common/utils/request'
  import SeriesCell from '@/components/player/tabs/series/SeriesCell.vue'

  export default {
    name: 'MovieSeriesContentList',
    components: {
      SeriesCell,
    },
    props: {
      contentInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        seriesCellList: [],
        isLoading: true,
        isOdd: false,
      }
    },
    created() {
      this.setData()
    },
    methods: {
      setData() {
        this.isLoading = true
        const movieId = _.get(this.contentInfo, 'movieid', '')
        getMovieSeriesContents({ movieid: movieId }).then(({ data }) => {
          this.seriesCellList = _.get(data, 'cell_toplist.celllist', [])
          this.isOdd = this.seriesCellList.length % 2 === 1
          this.isLoading = false
        })
      },
    },
  }
</script>
<style lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .series-list-box {
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      Microsoft YaHei,
      simsun,
      ヒラギノ角ゴ ProN,
      Hiragino Kaku Gothic ProN,
      メイリオ,
      Meiryo,
      ＭＳ Ｐゴシック,
      MS PGothic,
      sans-serif;
    margin: -20px 100px 0px 100px;
    padding-bottom: 80px;
    .series-list {
      display: flex;
      flex-wrap: wrap;
      .item {
        display: flex;
        flex-direction: row;
        width: 50%;
        padding: 20px 0 20px 40px;
        border-top: 1px solid #2f2f2f;
      }
      .item:nth-of-type(odd) {
        padding-left: 0;
      }
      .item:nth-of-type(1),
      .item:nth-of-type(2) {
        border-top: 0;
      }
      .thumb-box {
        flex: none;
        position: relative;
        overflow: hidden;
        width: 185px;
        height: 278px;
        background-color: $neutral-30;
        border-radius: 12px;
      }
      .thumb-box .no-thumb {
        @include Position(absolute, $left: 0, $right: 0, $top: 0, $bottom: 0);
        display: flex;
        flex-direction: column;
        background-color: #252525;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        z-index: 10;
      }
      .thumb-box .no-thumb .alt-text {
        @include Ellipsis($multi: true, $line: 2);
        overflow: hidden;
        word-wrap: break-word;
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 29px;
        white-space: inherit;
      }
      .thumb-box img {
        width: 100%;
      }
    }
    .paging-type01 {
      margin-top: 40px;
      padding: 0;
    }
  }
</style>
